export function installClinicalCommitGuard(store) {
  const commit = store.commit.bind(store)
  store.commit = (type, payload, options) => {
    const mutationType = typeof type === 'object' ? type.type : type
    const clinicalMutation = /^(examinations|patients|report|screenshots)\//.test(mutationType)
    const allowedClear = /\/clearLicenseRestrictedState$/.test(mutationType)
    if (store.state.clinicalStateLocked && clinicalMutation && !allowedClear) return
    return commit(type, payload, options)
  }
}

const CLINICAL_TOKEN = Symbol('clinicalRequestToken')
const STALE_CLINICAL_ACTION = 'STALE_CLINICAL_ACTION'

function currentRequest(rootState, requestEpoch) {
  return !rootState.clinicalStateLocked && rootState.clinicalRequestEpoch === requestEpoch
}

function staleActionError() {
  const error = new Error(STALE_CLINICAL_ACTION)
  error.code = STALE_CLINICAL_ACTION
  return error
}

function isStaleActionError(error) {
  return error && (error.code === STALE_CLINICAL_ACTION || String(error.message || error).includes(STALE_CLINICAL_ACTION))
}

// 每次 action 啟動時固定其 epoch；即使授權先停用再恢復，舊 request 也不得回填 PHI。
export function guardClinicalActions(actions) {
  return Object.keys(actions).reduce((guarded, name) => {
    guarded[name] = (context, payload) => {
      const inherited = payload && typeof payload === 'object' && payload[CLINICAL_TOKEN]
      const requestEpoch = inherited ? inherited.epoch : context.rootState.clinicalRequestEpoch
      const actionPayload = inherited ? inherited.payload : payload
      if (!currentRequest(context.rootState, requestEpoch)) return Promise.resolve()
      const guardedContext = {
        ...context,
        commit(type, value, options) {
          if (!currentRequest(context.rootState, requestEpoch)) throw staleActionError()
          return context.commit(type, value, options)
        },
        dispatch(type, value, options) {
          if (!currentRequest(context.rootState, requestEpoch)) return Promise.reject(staleActionError())
          const chainedPayload = { [CLINICAL_TOKEN]: { epoch: requestEpoch, payload: value } }
          return Promise.resolve(context.dispatch(type, chainedPayload, options))
            .then((result) => {
              if (!currentRequest(context.rootState, requestEpoch)) throw staleActionError()
              return result
            })
        },
      }
      return Promise.resolve(actions[name](guardedContext, actionPayload))
        .then((result) => currentRequest(context.rootState, requestEpoch) ? result : undefined)
        .catch((error) => isStaleActionError(error) ? undefined : Promise.reject(error))
    }
    return guarded
  }, {})
}
